import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ReportIssueModal from './ReportIssueModal';
import { screenContext } from '../../utils/issueReports';

/*
 * One Report an issue dialog for the whole app (2026-10-15), so it can be
 * opened from any screen, any dialog, any step of any tool -- by the header's
 * icon, Field Mode's flag, the camera's chip, or the edge tab every signed-in
 * screen shows (ReportIssueTab).
 *
 * Opening it first reads which screen the person is on (screenContext: the
 * dialog in front, else the page's heading), before the report's own dialog
 * is on the page; the report carries it as its page_title.
 *
 * Without a provider (a screen rendered on its own, as unit tests do) the
 * triggers keep a dialog of their own: useIssueReport() answers null.
 */
const IssueReportContext = createContext(null);

export function IssueReportProvider({ children }) {
  const [opened, setOpened] = useState(null);   // { context } while open
  const openReport = useCallback(() => {
    setOpened(current => current || { context: screenContext() });
  }, []);
  const close = useCallback(() => setOpened(null), []);
  const value = useMemo(() => ({ openReport, isOpen: !!opened }), [openReport, opened]);
  return (
    <IssueReportContext.Provider value={value}>
      {children}
      <ReportIssueModal open={!!opened} context={opened?.context || null} onClose={close} />
    </IssueReportContext.Provider>
  );
}

/** { openReport, isOpen } inside the provider, else null. */
export const useIssueReport = () => useContext(IssueReportContext);
